<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <div class="page">
                <div class="vertical-flow">
                    <!-- TÍTULO -->
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t('rentabilidade') }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t('vendas') }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('rentabilidade') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create && !tabelaIntegracao"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="$router.push({ name: 'ven-rentabilidade-new' })"
                            >
                                {{ $t('adicionar') }}
                            </button>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-multiline">
                        <div class="column is-9">
                            <search-bar :onSearch="debouncedOnSearch" />
                        </div>
                        <div class="column is-3">
                            <vss-select
                                ref="situacoes"
                                :searchable="false"
                                :options="situacoes"
                                v-model="filters.situacao"
                                mlLabels
                                title="situacao"
                                clearable
                                @input="onSituacaoChanged"
                                :height="40"
                            />
                        </div>
                    </div>

                    <!-- TABELA DE RENTABILIDADE -->
                    <div class="registry-wrapper">
                        <container-loader v-if="isLoading && !$store.getters.isLoading" />
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="allprofitability"
                            :mobile-cards="false"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                                :class="{
                                    'excluir-field': f.key == 'excluir',
                                }"
                            >
                                <div v-if="f.key == 'codigo'">
                                    <router-link
                                        :to="{
                                            name: 'ven-rentabilidade-edit',
                                            params: {
                                                id: props.row['id'],
                                            },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>

                                <div
                                    v-else-if="
                                        f.key == 'excluir' && !tabelaIntegracao && permissao.update
                                    "
                                >
                                    <b-button
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['situacao'] == 1 ? 'delete' : 'check'
                                        "
                                        @click="promptChangeSituacao(props.row)"
                                        v-tippy 
                                        :title="$t(
                                            props.row['situacao'] == 1
                                                ? 'desativar'
                                                : 'reativar'
                                        )"
                                    />
                                </div>

                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        v-if="props.row[f.key] == 1"
                                        class="table-tag table-tag-full-width"
                                        type="is-success"
                                        size="is-medium"
                                    >
                                        {{ $t('ativo') }}
                                    </b-tag>
                                    <b-tag
                                        v-else
                                        class="table-tag table-tag-full-width"
                                        type="is-danger"
                                        size="is-medium"
                                    >
                                        {{ $t('inativo') }}
                                    </b-tag>
                                </div>

                                <div v-else-if="f.key == 'cor'">
                                    <div
                                        class="color-block"
                                        :style="{ 'background-color': props.row[f.key] }"
                                    ></div>
                                </div>
                                <div v-else-if="f.key == 'empresa'">
                                    {{
                                        !props.row[f.key]
                                            ? $t('todos').toUpperCase()
                                            : props.row[f.key]
                                    }}
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import RentabilidadeService from '@/services/vendas/RentabilidadeService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes('ven-rentabilidade') && to.name != 'ven-rentabilidade-list') {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados();
            next();
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            allprofitability: [],
            service: new RentabilidadeService(this.$http, this.$router),
            tabelaIntegracao: this.$store.state.user.tabelasERPWebServer.includes('RENTABILIDADE'),
            permissao: {},
            fields: [
                { key: 'codigo', width: '10%', sortable: true, sortFn: null },
                { key: 'empresa', width: null, sortable: true, sortFn: null },
                { key: 'percentual', width: null, sortable: true, sortFn: null },
                { key: 'tipo', width: null, sortable: true, sortFn: null },
                { key: 'cor', width: null, sortable: false, sortFn: null },
                { key: 'situacao', width: 70, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            isLoading: false,
            isEmpty: true,
            queryFilter: '',
            delete: null,
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            filters: {
                situacao: { id: 2, label: 'todos' },
                column: 'tipo',
                order: 'asc',
                queryFilter: '',
            },
        };
    },
    created() {
        if (
            this.$route.name.includes('ven-rentabilidade') &&
            this.$route.name != 'ven-rentabilidade-list'
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'ven-rentabilidade');

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'rentabilidade' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.filters.column,
                    this.filters.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.filters.situacao.id,
                    this.filters.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.allprofitability = value;
                    this.isEmpty = this.allprofitability.length <= 0;
                })
                .catch((e) => {
                    console.error('Erro ao carregar listagem de rentabilidade.', e);
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load-rentabilidade');
                })
                .finally(() => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let list = body.content.map((m) => {
                return {
                    id: m.id,
                    codigo: m.idrentabilidadeerp,
                    empresa: m.empresa.nome,
                    percentual: this.parseAsPercent(m.percentual),
                    tipo: m.tipo,
                    cor: m.cor,
                    situacao: m.situacao,
                };
            });
            return list;
        },
        onSituacaoChanged(val) {
            this.filters.situacao = val
                ? this.situacoes.find((v) => v.id == val.id)
                : this.situacoes[0];
            this.carregarDados();
        },
        sortTable(field, order) {
            this.filters.column = field;
            this.filters.order = order;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row.codigo }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacao,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacao() {
            let rentabilidade = {
                idrentabilidade: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.service
                .updateSituacao(rentabilidade)
                .then((r) => {
                    if (r.status == 200) {
                        let messageSuccess = this.$t(
                                r.content.situacao == 1
                                    ? 'msg-sucesso-ao-reativar'
                                    : 'msg-sucesso-ao-desativar', 
                                { n: this.$t('rentabilidade') }
                            );

                        this.$root.showMessage('success', messageSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);

                    let messageFail = this.$t(
                            this.delete.situacao == 1
                                ? 'msg-erro-ao-desativar'
                                : 'msg-erro-ao-reativar', 
                            { n: this.$t('rentabilidade') }
                        );

                    this.$root.showMessage('error', messageFail, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updatePagination(val) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = val.perPage;
            this.pagination.currentPage = val.currentPage;
            this.carregarDados(val.currentPage);
        },
        onSearch(value) {
            this.filters.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .situacao-select div,
        .produtivo-select div {
            height: 40px;
        }
    }

    .data-table {
        padding: 0;
    }

    .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;

        .search-bar {
            width: 100%;
        }
    }
}
</style>
